/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Right-Arrow': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M5.04 11.932l1.211 1.213 5.178-5.178L6.25 2.789 5.04 4.002l3.965 3.965-3.965 3.965z" _fill="#000"/><mask id="svgicon_Right-Arrow_a" maskUnits="userSpaceOnUse" x="5" y="2" width="7" height="12"><path pid="1" d="M5.04 11.932l1.211 1.213 5.178-5.178L6.25 2.789 5.04 4.002l3.965 3.965-3.965 3.965z" _fill="#fff"/></mask><g mask="url(#svgicon_Right-Arrow_a)"><path pid="2" _fill="#2D75F5" d="M16 16H0V0h16z"/></g>'
  }
})
